// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wKWPd","questions":"styles_questions__1_NUV","footer":"styles_footer__3IXju"};